
define('jst!filefinder/_badge_count',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if(count > 0)  { %>\n  <span class="badge-count <%= className %>">\n    <%= count  %>\n  </span>\n<% } %>\n');
 });

